<template>
  <div class="list-table">
    <div class="sticky" v-show="!isMobile">
      <div class="scroll-table">
        <table>
          <thead>
            <th>Logo</th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'username'}"
              @click="sort('username')">
              Username
              <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
                v-show="currentOrder.field === 'username'"></i>
            </th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'name'}"
              @click="sort('name')">
              Name
              <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
                v-show="currentOrder.field === 'name'"></i>
            </th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'contactEmail'}"
              @click="sort('contactEmail')">
              Email
              <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
                v-show="currentOrder.field === 'contactEmail'"></i>
            </th>
            <th :class="{'sortable':true, 'active':currentOrder.field === 'contactPhone'}"
              @click="sort('contactPhone')">
              Mobile
              <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
                v-show="currentOrder.field === 'contactPhone'"></i>
            </th>
            <th><i class="fab fa-stripe-s"></i></th>
            <th>Status</th>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td class="email-logo"><img :src="user.logo"></td>
              <td><a :href="'/#/corporate/' + user.id" target="_blank">{{ user.username }}</a></td>
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.mobile }}</td>
              <td class="stripe">
                <a :href="user.stripeUrl" v-if="user.stripeUrl" target="_blank">
                  <i class="fa fa-link"></i>
                </a>
                <span class="fa-stack" v-else>
                  <i class="fa fa-link fa-stack-1x"></i>
                  <i class="fas fa-slash fa-stack-1x" style="color:Tomato"></i>
                </span>
              </td>
              <td class="status">
                <div class="switch">
                  <div :class="{'slider':true, 'active':user.active, 'disabled':statusLoading.indexOf(user.id) > -1}"
                    @click="toggleStatus(user.id, user.active)"></div>
                  <span class="label" v-if="user.active">ACTIVE</span>
                  <span class="label" v-else>DEACTIVATED</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="scroll-table" v-show="!isMobile">
      <table class="main-table">
        <thead>
          <th>Logo</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'username'}"
            @click="sort('username')">
            Username
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'username'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'name'}"
            @click="sort('name')">
            Name
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'name'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'contactEmail'}"
            @click="sort('contactEmail')">
            Email
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'contactEmail'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'contactPhone'}"
            @click="sort('contactPhone')">
            Mobile
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'contactPhone'"></i>
          </th>
          <th><i class="fab fa-stripe-s"></i></th>
          <th>Status</th>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td class="email-logo"><img :src="user.logo"></td>
            <td><a :href="'/#/corporate/' + user.id" target="_blank">{{ user.username }}</a></td>
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.mobile }}</td>
            <td class="stripe">
              <a :href="user.stripeUrl" v-if="user.stripeUrl" target="_blank">
                <i class="fa fa-link"></i>
              </a>
              <span class="fa-stack" v-else>
                <i class="fa fa-link fa-stack-1x"></i>
                <i class="fas fa-slash fa-stack-1x" style="color:Tomato"></i>
              </span>
            </td>
            <td class="status">
              <div class="switch">
                <div :class="{'slider':true, 'active':user.active, 'disabled':statusLoading.indexOf(user.id) > -1}"
                  @click="toggleStatus(user.id, user.active)"></div>
                <span class="label" v-if="user.active">ACTIVE</span>
                <span class="label" v-else>DEACTIVATED</span>
              </div>
            </td>
          </tr>

          <tr v-show="loading && users.length === 0">
            <td colspan="7" class="table-block">
              <transition name="slide-up">
                <div v-show="loading" class="loader">
                  <i class="fas fa-spinner fa-spin"></i>
                  Getting corporate profiles...
                </div>
              </transition>
            </td>
          </tr>

          <tr v-show="users.length === 0 && !loading">
            <td colspan="7" class="table-block">
              <transition name="slide-up">
                <div v-show="users.length === 0 && !loading" class="empty-result">
                  <i class="far fa-frown-open fa-3x"></i><br/>
                  No record found!
                </div>
              </transition>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="cards" v-if="isMobile">
      <div class="card" v-for="user in users" :key="user.id">
        <div class="email-logo"><img :src="user.logo !='#' ? user.logo : 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png'"></div>
        <div class="info">
          <div class="card-header">
            <div class="name-stripe">
              <span class="name">
                {{ user.name }}
              </span>
              <span class="stripe">
                <a :href="user.stripeUrl" v-if="user.stripeUrl" target="_blank">
                  <i class="fa fa-link"></i>
                </a>
                <span class="fa-stack" v-else>
                  <i class="fa fa-link fa-stack-1x"></i>
                  <i class="fas fa-slash fa-stack-1x" style="color:Tomato"></i>
                </span>
              </span>
            </div>
            <div class="switch">
              <div :class="{'slider':true, 'active':user.active, 'disabled':statusLoading.indexOf(user.id) > -1}"
                @click="toggleStatus(user.id, user.active)"></div>
            </div>
          </div>
          <div class="title">
            <div class="value"><i class="fas fa-address-card"></i> <a :href="'/#/corporate/' + user.id" target="_blank">{{ user.username }}</a></div>
          </div>
          <div class="title">
            <div class="value"><i class="fas fa-envelope"></i> {{ user.email }}</div>
          </div>
          <div class="title">
            <div class="value"><i class="fas fa-phone"></i> {{ user.mobile }}</div>
          </div>
        </div>
      </div>
      <div v-show="loading && users.length === 0">
        <transition name="slide-up">
          <div v-show="loading" class="loader">
            <i class="fas fa-spinner fa-spin"></i>
            Getting corporate profiles...
          </div>
        </transition>
      </div>

      <div v-show="users.length === 0 && !loading">
        <transition name="slide-up">
          <div v-show="users.length === 0 && !loading" class="empty-result">
            <i class="far fa-frown-open fa-3x"></i><br/>
            No record found!
          </div>
        </transition>
      </div>
    </div>

    <div class="fix-footer">
      <!-- <div class="row">
        <div class="small-6 columns small-offset-3 pagination prev-next">
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev2">
            <i class="fas fa-chevron-left"></i>
            Prev
          </span>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next2">
            Next
            <i class="fas fa-chevron-right"></i>
          </span>
        </div> -->
        <div class="small-4 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-4 columns page-data">
          <span v-show="users.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-4 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i" :key="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
    </div>
  </div>
</template>

<script>
import ApiCorporateList from '@/modules/api/corporate/list'
import ApiCorporateProfile from '@/modules/api/corporate/profile'

export default {
  name: 'list-table',
  props: ['isMobile'],
  data () {
    return {
      statusLoading: []
    }
  },
  computed: {
    users () { return this.$store.state.corporate.users.list },
    loading () { return this.$store.state.corporate.users.loading },
    currentOrder () {
      let tableData = this.$store.state.corporate.users
      return { field: tableData.order, asc: tableData.orderAsc }
    },
    perPage: {
      get: function () { return this.$store.state.corporate.users.perPage },
      set: function (value) {
        this.$store.commit('corporate/setUserPerPage', parseInt(value))
        this.$store.commit('corporate/setUserCurrentPage', 1)
        this.getList()
      }
    },
    pageData () {
      let tableData = this.$store.state.corporate.users
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.$store.state.corporate.users.currentPage },
      set: function (value) {
        this.$store.commit('corporate/setUserCurrentPage', parseInt(value))
        this.getList()
      }
    },
    isLastPage () {
      let tableData = this.$store.state.corporate.users
      return (tableData.currentPage * tableData.perPage) >= tableData.maxList
    },
    totalPage () {
      let tableData = this.$store.state.corporate.users
      return Math.ceil(tableData.maxList / tableData.perPage)
    }
  },
  methods: {
    getList () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('corporate/resetUsers')
      self.$store.commit('corporate/setUserLoading', true)
      ApiCorporateList.getList(self, res => {
        self.$store.commit('corporate/setUserLoading', false)
      })
    },
    sort (field) {
      if (this.loading) { return }
      let tableData = this.$store.state.corporate.users
      if (field !== tableData.order) {
        this.$store.commit('corporate/setUserOrderAsc', 1)
      } else {
        this.$store.commit('corporate/setUserOrderAsc', tableData.orderAsc === 1 ? 0 : 1)
      }
      this.$store.commit('corporate/setUserOrder', field)
      this.$store.commit('corporate/setUserCurrentPage', 1)
      this.getList()
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('corporate/setUserCurrentPage', this.$store.state.corporate.users.currentPage - 1)
      this.getList()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('corporate/setUserCurrentPage', this.$store.state.corporate.users.currentPage + 1)
      this.getList()
    },
    prev2 () {
      if (this.currentPage === 1) { return }
      this.$store.commit('corporate/setUserCurrentPage', this.$store.state.corporate.users.currentPage - 1)
      this.getList()
    },
    next2 () {
      if (this.isLastPage) { return }
      this.$store.commit('corporate/setUserCurrentPage', this.$store.state.corporate.users.currentPage + 1)
      this.getList()
    },
    toggleStatus (id, isActive) {
      let self = this
      if (self.statusLoading.indexOf(id) > -1) { return }

      self.statusLoading.push(id)
      ApiCorporateProfile.toggleStatus(self, {id: id, active: isActive}, res => {
        if (!res.error) {
          let index = self.statusLoading.indexOf(id)
          self.statusLoading.splice(index, 1)
  
          self.$store.commit('corporate/updateUserStatus', {id: id, active: res.list[0].active})
        }
      })
    }
  },
  mounted () {
    this.$store.commit('corporate/setUserCurrentPage', 1)
    this.getList()
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>
.list-table{
  background: #fff;
  border-radius: 3px;
  position: relative;
  min-height: 100px;
  overflow: hidden;
}

.sticky{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 30px;
  z-index: 3;

  .scroll-table::-webkit-scrollbar { visibility: hidden; }
  tbody{ visibility: hidden; }
}

.scroll-table{
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 290px);
  min-height: 400px;
}

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border-bottom: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,0.3);
      border-bottom: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
    
  }

  .email-logo img{
    max-width: 100px;
    max-height: 100px;
  }
  .stripe{
    font-size: 16px;
    .fa-link{ color: #0D79F2; }
    span .fa-link{ opacity: .4; }
  }
  .status, a{ cursor: pointer; }
  .status{ width: 110px; }
}

.switch{
  position: relative;
  display: inline-block;

  .slider{
    position: relative;
    margin-bottom: 3px;
    display: inline-block;
    width: 50px;
    height: 26px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .25s ease-in-out;

    &.disabled{ opacity: .4; }
    &:before{
      content: '';
      position: absolute;
      top: 2px;
      left: 3px;
      width: 21px;
      height: 21px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 25px; }
    }
  }
  .label{
    display: block;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    color: #555;
    text-transform: uppercase;
  }
}

.fix-footer{
  width: 100%;
  height: 60px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{ max-width: 100px; }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 15px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 15px 0;
  }
  .pagination{
    text-align: right;
    padding: 15px 10px;

    &.prev-next{ text-align: center; }

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .6s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .fix-footer {
    .row {
      display: flex;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;
      padding: 15px 0px;
      margin-right: 15%;

      select {
        width: 55px;
      }
    }
  }

  .loader, .empty-result {
    text-align: center;
    padding: 50px 0;
  }

  .cards {
    width: 90%;
    margin: 0 auto;
    margin-top: 20px;
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      display: flex;

      .info {
        width: 100%;
        padding-left: 10px;
      }

      > div {
        margin-bottom: 3px;
      }

      .email-logo {
        img {
          max-width: 100px;
          max-height: 100px;
        }
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
          .name-stripe {
            font-size: 16px;
            color: #000;
            font-weight: 900;
            display: flex;
            gap: 5px;
            width: 150px;
            align-items: center;
            .name {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis; 
            }
          }
      }

      .credit-card {
        font-weight: 900;
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 3px;

        input {
          margin-right: 5px;
        }

        &.view {
          justify-content: space-between;
          padding-top: 7px;
          padding-bottom: 5px;
          border-top: 1px solid #eee;
        }

        .refer {
          display: flex;
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Corporate/ListTable.vue